<section class="d-body  hidden">
  <iq-central-front-end-navbar></iq-central-front-end-navbar>

  <section class="container my-5">
    <div class="bg-white border-radius">
      <div class="font18 px-4 pt-5 mt-4">
        Mentees
      </div>
      <hr />
      <div class="px-4 pb-5">
        <div class="list-view__wrapper">
          <div class="text-center">
            <div
            class="font20 d-flex align-items-center m-auto"
            *ngIf="mentees?.length == 0"
            >
              <img src="assets/icons/info.png" alt="" />
              <div class="ml-3 text-green font-light">
                You have no mentee yet
              </div>
            </div>
          </div>
          <div class="card-table table-responsive ">
            <table class="table no-wrap" id="myTable">
              <tbody>
                <tr class="my-4" *ngFor="let mentee of mentees">
                  <td class="mx-3 no-wrap">
                    <div class="d-flex align-items-center">
                      <div class="mr-3">
                        <img 
                          src="{{
                            mentee?.user?.avatarUrl
                            ? mentee?.user?.avatarUrl
                            :'assets/images/avatar.jpg'}}" 
                          alt="" height="50" width="50"
                          class="rounded-circle" 
                        />
                      </div>
                      <div>
                        <p class="mb-1 font14">{{ mentee?.user?.fullName }}</p>
                        <p class="mb-0 font14 text-grey">
                          {{ mentee?.user?.username }}
                        </p>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div>
                      <p class="mb-1 font14 text-grey">Learning Path</p>
                      <p class="mb-0 font14">{{ mentee?.designation?.name }}</p>
                    </div>
                  </td>
                  <td>
                    <div>
                      <p class="mb-1 font14 text-grey">Date</p>
                      <p class="mb-0 font14">{{ mentee?.createdAt | date }}</p>
                    </div>
                  </td>
                  <td>
                    <div>
                      <p class="mb-1 font14 text-grey">Duration</p>
                      <p class="mb-0 font14">6-Month</p>
                    </div>
                  </td>
                  <td>
                    <div>
                      <p class="mb-1 font14 text-grey">Stage</p>
                      <p class="mb-0 font14">80% done</p>
                    </div>
                  </td>
                  <td>
                    <div>
                      <button
                        class="btn btn-outline-primary btn-sm "
                        [routerLink]="['/staff/staff-details', mentee.id]"
                      >
                        view
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="mt-auto container">
    <hr />
    <iq-central-front-end-footer></iq-central-front-end-footer>
  </div>
</section>
